<template>
	<tr :class="rootClass">
		<td scope="row" class="td_board" v-if="!isSearch">
			<div class="board_state">
				<template v-if="showsBoardName">
					<span class="ico_bbs ico_current" v-if="isCurrentArticle">현재 보고있는 페이지</span>
					<a :href="boardUrl" class="txt_name" v-html="boardName" @click="onBoardClick"></a>
				</template>
				<div class="wrap_num" v-else>
					<span class="ico_bbs ico_current" v-if="isCurrentArticle">현재 보고있는 페이지</span>
					{{ dataid }}
				</div>
			</div>
		</td>

		<td scope="row" class="td_title">
			<span class="link_board">
				<strong class="tit_board">
					<span class="ico_bbs ico_reply" v-if="isReply" :style="replyIconStyle"><span class="sr_only">답글</span></span>
					<span class="title_wrapper" :style="replyTitleStyle">
						<a :href="url" class="txt_item" v-html="title" @click="onTitleClick"></a>
						<a href="javascript:" class="num_count_g" v-if="hasComment" @click="openCommentPopup">
							<span class="screen_out">댓글수</span>
							<span class="num_item" :class="commentCountClass">{{ shrtcmtcnt }}</span>
						</a>
						<article-icons v-if="showsArticleIcons" v-bind="iconsProps"/>
					</span>
				</strong>
			</span>
		</td>

		<td scope="row" class="td_writer" v-if="showsAuthor">
			<a href="javascript:" class="txt_writer" @click="_openLayer">{{ nickname || '(익명)' }}</a>
		</td>

		<td scope="row" class="td_date">
			<span class="tbl_txt_date">{{ regdtshow }}</span>
		</td>

		<td scope="row" class="td_recommend" v-if="!isSearch">
			<span class="tbl_txt_recommend">{{ recmdcnt }}</span>
		</td>

		<td scope="row" class="td_look">
			<span class="tbl_txt_look">{{ viewcount }}</span>
		</td>
	</tr>
</template>

<script>
import ArticleIcons from '../../components/list/ArticleIcons.vue';
import {openLayer} from '../../components/layer/event-bus.mjs';
import {mapState, mapGetters} from 'vuex';

export default {
	inheritAttrs: false,
	components: {ArticleIcons},

	// article 데이터를 props 로 받음.
	props: {
		grpid: {type: String},
		fldid: {type: String},
		dataid: {type: [String, Number]},

		fldname: {type: String, default: ''},
		parid: {type: Number, default: 0},
		dataname: {type: String},
		shrtcmtcnt: {type: Number},
		isNewCmt: {type: Boolean},
		regdtshow: {type: String},
		recmdcnt: {type: Number, default: 0},
		viewcount: {type: Number},
		bbsdepth: {type: String, default: ''},

		addimgyn: {type: String, default: ''},
		movieyn: {type: String, default: ''},
		addfileyn: {type: String, default: ''},
		pollyn: {type: String, default: ''},
		isEscrow: {type: Boolean, default: false},
		isEscrowEnd: {type: Boolean, default: false},
		isNew: {type: Boolean, default: false},

		userid: {type: String, default: ''},
		nickname: {type: String, default: ''},
		encUserid: {type: String, default: ''}
	},
	data() {
		return {
			SHOWING_BOARD_NAME_LENGTH: 8
		};
	},
	computed: {
		...mapState({
			currentDataid: 'dataid',
			myUserId: 'userId',
			isAnonymous: 'isAnonymous',
			query: 'query',
			searchCtx: 'searchCtx',
			page: 'page',
			prevPage: 'prevPage',
			listNum: 'listNum',
			params: 'params',
			plainRegdt: 'plainRegdt',
			firstBbsDepth: 'firstBbsDepth',
			lastBbsDepth: 'lastBbsDepth',
			isAdmin: 'isAdmin',
			isBoardAdmin: 'isBoardAdmin',
			rolecode: 'rolecode',
			cafeRoles: 'cafeRoles'
		}),
		...mapGetters(['isSearch', 'isRecent', 'isFavor', 'isArticle']),
		rootClass() {
			return {
				article_mine: !this.isSearch && this.isMine,
				current_board: this.isCurrentArticle
			};
		},
		isMine() {
			return this.userid === this.myUserId;
		},
		isCurrentArticle() {
			return this.dataid.toString() === this.currentDataid;
		},
		showsBoardName() {
			return this.isRecent || this.isFavor;
		},
		boardUrl() {
			return `/_c21_/bbs_list?grpid=${this.grpid}&fldid=${this.fldid}`;
		},
		boardName() {
			if (this.fldname.length <= this.SHOWING_BOARD_NAME_LENGTH) {
				return this.fldname;
			}

			return `${this.fldname.slice(0, this.SHOWING_BOARD_NAME_LENGTH)}..`;
		},
		isReply() {
			return this.parid > 0;
		},
		replyIconStyle() {
			return {
				left: 0
			};
		},
		replyTitleStyle() {
			return {
				marginLeft: this.isReply ? '12px' : 0
			};
		},

		url() {
			if (this.isSearch) {
				return `/_c21_/bbs_nsread?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}&datanum=${this.dataid}
					&query=${encodeURIComponent(this.query)}&search_ctx=${this.searchCtx}&searchlist_uri=${encodeURIComponent('/_c21_/cafesearch')}`;
			}

			if (this.isRecent) {
				return `/_c21_/recent_bbs_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}&datanum=${this.dataid}
					&page=${this.page}&prev_page=${this.prevPage}&listnum=${this.listNum}`;
			}

			if (this.isFavor) {
				return `/_c21_/favor_bbs_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}&datanum=${this.dataid}
					&favorRegdate=${this.params.date || this.params.favorRegdate || this.plainRegdt}&favorMode=${this.params.mode || this.params.favorMode || 'view'}`;
			}

			return `/_c21_/bbs_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}&datanum=${this.dataid}
				&page=${this.page}&prev_page=${this.prevPage}&firstbbsdepth=${this.firstBbsDepth}&lastbbsdepth=${this.lastBbsDepth}&listnum=${this.listNum}`;
		},
		title() {
			// 기존 동작 방식대로 <...>를 제거하고 v-html 로 넣는다.
			return this.dataname.replace(/<[^>]+>/g, '');
		},
		hasComment() {
			return this.shrtcmtcnt > 0;
		},
		commentCountClass() {
			return {
				new_comment: this.isNewCmt
			};
		},
		showsArticleIcons() {
			return !this.isSearch;
		},
		iconsProps() {
			return {
				hasImage: this.addimgyn === 'Y',
				hasVideo: this.movieyn === 'Y',
				hasFile: this.addfileyn === 'Y',
				hasPoll: this.pollyn === 'Y',
				isSafeTrade: this.isEscrow,
				isSold: this.isEscrowEnd,
				isNew: this.isNew
			};
		},
		showsAuthor() {
			return !this.isArticle || !this.isAnonymous;
		}
	},
	methods: {
		openCommentPopup(e) {
			window.viewShortComment(this.fldid, this.dataid);
			CafeTiara.trackEvent(e, '댓글보기(팝업창)', 'comment_view_btn', '일반게시판>게시글>');
		},
		_openLayer(e) {
			if (this.userid === '') {
				return;
			}

			openLayer(e, 'user', {
				grpid: this.grpid,
				isAdmin: this.isAdmin,
				rolecode: this.rolecode,
				encUserId: this.encUserid,
				isMine: this.isMine,
				author: this.nickname,
				cafeRoles: this.cafeRoles,
				canEditRolecode: this.isAdmin || this.isBoardAdmin
			});

			CafeTiara.trackEvent(e, '회원 닉네임 클릭', 'member_profile', '일반게시판>게시글>');
		},
		onTitleClick(e) {
			CafeTiara.trackEvent(e, '글뷰 하단 글목록 영역 클릭', 'article_title', '일반게시판>게시글>');
		},
		onBoardClick(e) {
			CafeTiara.trackEvent(e, '게시판명 클릭', 'board_title', '일반게시판>게시글>');
		}
	}
}
</script>
